import MetaTags from 'react-meta-tags';
import React from "react"
import { useParams, useHistory } from "react-router-dom"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  ListGroup,
  ListGroupItem
} from "reactstrap"

// Import icons
import {
  FaUsersCog,
  FaList,
  FaLocationArrow,
  FaMailchimp
} from "react-icons/fa"

import { Patners, Rates, Couriers, Pincodes, Branches, Employee, Roles, CourierRates } from "./modules";

const Settings = () => {
  const { category } = useParams();
  const history = useHistory();

  const categories = [
    { id: "patners", title: "Partners", icon: FaList, color: "warning" },
    { id: "Courier", title: "Couriers", icon: FaMailchimp, color: "info" },
    { id: "Rates", title: "Zones", icon: FaUsersCog, color: "info" },
    { id: "CourierRates", title: "Courier Rates", icon: FaList, color: "success" },
    { id: "Pincodes", title: "Pincodes", icon: FaLocationArrow, color: "danger" },
    { id: "Branches", title: "Branches", icon: FaUsersCog, color: "primary" },
    { id: "Employee", title: "Employees", icon: FaUsersCog, color: "secondary" },
    { id: "Roles", title: "Roles", icon: FaUsersCog, color: "warning" }
  ];

  const selectedCategory = category || "patners";

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Settings | {process.env.REACT_APP_TITLE}</title>
        </MetaTags>
        <Container fluid>
          <h4>Settings</h4>

          {
            <Row>
              <Col lg={3}>
                <Card>
                  <CardBody>
                    <ListGroup flush>
                      {categories.map((categoryItem) => (
                        <ListGroupItem
                          key={categoryItem.id}
                          tag="a"
                          href="#"
                          action
                          className="d-flex align-items-center"
                          active={selectedCategory === categoryItem.id}
                          onClick={(e) => {
                            e.preventDefault();
                            history.push(`/settings/${categoryItem.id}`);
                          }}
                        >
                          <categoryItem.icon className={`me-3 text-${categoryItem.color}`} />
                          <span>{categoryItem.title}</span>
                        </ListGroupItem>
                      ))}
                    </ListGroup>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={9}>
                <Row>
                  <Col lg={12}>
                    {selectedCategory === "patners" && <Patners />}
                    {selectedCategory === "Rates" && <Rates />}
                    {selectedCategory === "Courier" && <Couriers />}
                    {selectedCategory === "Pincodes" && <Pincodes />}
                    {selectedCategory === "CourierRates" && <CourierRates />}
                    {selectedCategory === "Branches" && <Branches />}
                    {selectedCategory === "Employee" && <Employee />}
                    {selectedCategory === "Roles" && <Roles />}
                  </Col>
                </Row>
              </Col>
            </Row>
          }

        </Container>
      </div>
    </React.Fragment>
  )
}

export default Settings;
